"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityAttendant(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 352c96 0 176-80 176-176S608 0 512 0 336 80 336 176s80 176 176 176zm0-288c60.8 0 112 51.2 112 112s-51.2 112-112 112-112-51.2-112-112S451.2 64 512 64zm0 320c-195.2 0-352 156.8-352 352 0 19.2 12.8 32 32 32h128v224c0 19.2 12.8 32 32 32h320c19.2 0 32-12.8 32-32V768h128c19.2 0 32-12.8 32-32 0-195.2-156.8-352-352-352zm160 320c-19.2 0-32 12.8-32 32v224H384V736c0-19.2-12.8-32-32-32H227.2c16-144 137.6-256 284.8-256s268.8 112 284.8 256H672z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityAttendant);
var _default = ForwardRef;
exports.default = _default;